import { heroStats } from "../data/content";
import CountUp from "./CountUp";

export default function StatsStrip() {
  return (
    <section data-testid="stats-strip" className="py-20 md:py-24" style={{ backgroundColor: "var(--primary)", color: "var(--bg)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
        {heroStats.map((s) => (
          <div key={s.label} data-testid={`strip-stat-${s.label.replace(/\s+/g, "-").toLowerCase()}`}>
            <div className="font-serif text-4xl md:text-5xl leading-none">
              <CountUp
                value={s.value}
                decimals={s.decimals}
                prefix={s.prefix || ""}
                duration={1500}
              />
              {s.unit && <span className="ml-1 text-base font-sans" style={{ color: "var(--accent-soft)" }}>{s.unit}</span>}
            </div>
            <div className="mt-3 text-[11px] tracking-[0.18em] uppercase font-semibold" style={{ color: "rgba(244,243,240,0.72)" }}>{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
